<template>
    <page
        :showBackButton="true"
        defaultHref="/services/schadensmeldung"
        ref="page"
    >
        <contract-card
            v-if="contractIdForCard !== ''"
            :contractId="contractIdForCard"
            :feature="feature"
            :shouldPresentContractSwitcherModal="
                shouldPresentContractSwitcherModal
            "
        ></contract-card>
        <h1>Schadensmeldung Rechtsschutz</h1>
        <form @submit.prevent="submitForm()">
            <stepper v-model="formData.formstep" :count="stepCount">
                <stepper-item class="u-form-p-bottom" :step="1">
                    <ion-card class="-light">
                        <base-input
                            id="polizzenversicherung"
                            v-model="formData.polizzenversicherung"
                            type="text"
                            label="Polizzen-Nr. RS-Versicherung"
                        ></base-input>
                        <ion-list lines="none">
                            <ion-item>
                                <base-checkbox
                                    id="rechtsschutz-kfz"
                                    v-model="formData.rechtsschutzKfz"
                                ></base-checkbox>
                                <ion-label>KFZ-Rechtsschutz</ion-label>
                            </ion-item>
                            <ion-item>
                                <base-checkbox
                                    id="rechtsschutz-lenker"
                                    v-model="formData.rechtsschutzLenker"
                                ></base-checkbox>
                                <ion-label>Lenker-Rechtsschutz</ion-label>
                            </ion-item>
                            <ion-item>
                                <base-checkbox
                                    id="rechtsschutz-lenker"
                                    v-model="formData.rechtsschutzSonstige"
                                ></base-checkbox>
                                <ion-label>Sonstige</ion-label>
                            </ion-item>
                        </ion-list>
                    </ion-card>
                    <personal-data
                        :geschlecht.sync="formData.geschlecht"
                        :titel.sync="formData.titel"
                        :vorname.sync="formData.vorname"
                        :zuname.sync="formData.zuname"
                        :strasse.sync="formData.strasse"
                        :hausnr.sync="formData.hausnr"
                        :stiege.sync="formData.stiege"
                        :stock.sync="formData.stock"
                        :tuer.sync="formData.tuer"
                        :plz.sync="formData.plz"
                        :ort.sync="formData.ort"
                        :email.sync="formData.email"
                        :telefon.sync="formData.telefon"
                        :geburtsdatum.sync="formData.geburtsdatum"
                        suffix=" *"
                    ></personal-data>
                    <ion-button
                        expand="block"
                        class="ion-margin-top ion-margin-bottom"
                        @click="submitForm()"
                        >Weiter</ion-button
                    >
                </stepper-item>
                <stepper-item
                    class="u-form-p-bottom"
                    :step="2"
                    v-if="showInvolvedVehicles"
                >
                    <involved-vehicles
                        :kfzart.sync="formData.kfzart"
                        :kfzmarke.sync="formData.kfzmarke"
                        :kmstand.sync="formData.kmstand"
                        :beteiligtKfzart.sync="formData.beteiligtKfzart"
                        :beteiligtKfzmarke.sync="formData.beteiligtKfzmarke"
                        :beteiligtKennzeichennummer.sync="
                            formData.beteiligtKennzeichennummer
                        "
                        :beteiligtKfzversicherung.sync="
                            formData.beteiligtKfzversicherung
                        "
                        :beteiligtPolizze.sync="formData.beteiligtPolizze"
                        :isOtherKfzInvolved.sync="isOtherKfzInvolved"
                    ></involved-vehicles>
                    <ion-grid>
                        <ion-row class="ion-margin-top ion-margin-bottom">
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="stepBack()"
                                    fill="outline"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col size="6">
                                <ion-button expand="block" @click="submitForm()"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
                <stepper-item
                    class="u-form-p-bottom"
                    :step="2 + showInvolvedVehicles"
                >
                    <accident-data
                        :unfallDatum.sync="formData.unfallDatum"
                        :unfallUhrzeit.sync="formData.unfallUhrzeit"
                        :unfallStrasse.sync="formData.unfallStrasse"
                        :unfallHausnr.sync="formData.unfallHausnr"
                        :unfallStiege.sync="formData.unfallStiege"
                        :unfallStock.sync="formData.unfallStock"
                        :unfallTuer.sync="formData.unfallTuer"
                        :unfallPlz.sync="formData.unfallPlz"
                        :unfallOrt.sync="formData.unfallOrt"
                        :unfallLand.sync="formData.unfallLand"
                        :unfallBeschreibung.sync="formData.unfallBeschreibung"
                        @place-is-home-address="fillPlaceData()"
                    ></accident-data>
                    <ion-card class="-light">
                        <base-textarea
                            id="vorfall-verhindern"
                            v-model="formData.vorfallVerhindern"
                            label="Wie hätte der Gegner den Vorfall verhindern können?"
                        ></base-textarea>
                    </ion-card>
                    <ion-card class="-light">
                        <ion-list-header>Strafverfahren</ion-list-header>
                        <ion-grid>
                            <ion-row>
                                <ion-col>
                                    <ion-list lines="none">
                                        <ion-item>
                                            <base-checkbox
                                                id="tatbestandsaufnahme-polizei"
                                                v-model="
                                                    formData.tatbestandsaufnahmePolizei
                                                "
                                            ></base-checkbox>
                                            <ion-label text-wrap
                                                >Aufnahme des Tatbestandes durch
                                                die Polizei</ion-label
                                            >
                                        </ion-item>
                                        <ion-item>
                                            <base-checkbox
                                                id="strafverfahren"
                                                v-model="
                                                    formData.strafverfahren
                                                "
                                            ></base-checkbox>
                                            <ion-label text-wrap
                                                >Strafverfahren wurde
                                                eingeleitet</ion-label
                                            >
                                        </ion-item>
                                    </ion-list>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <beteiligte-data
                        :formData="formData"
                        @person-added="formData.beteiligte.push($event)"
                        @delete-person="formData.beteiligte.splice($event, 1)"
                    >
                    </beteiligte-data>
                    <ion-grid>
                        <ion-row class="ion-margin-top ion-margin-bottom">
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="stepBack()"
                                    fill="outline"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col size="6">
                                <ion-button expand="block" @click="submitForm()"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
                <stepper-item
                    class="u-form-p-bottom"
                    :step="3 + showInvolvedVehicles"
                >
                    <ion-card class="-light">
                        <ion-grid>
                            <ion-row>
                                <ion-col size="12">
                                    <base-select
                                        v-model="formData.ansprueche"
                                        id="ansprueche"
                                        label="Ansprüche"
                                    >
                                        <ion-select-option
                                            value="Reparaturkosten"
                                            >Reparaturkosten</ion-select-option
                                        >
                                        <ion-select-option
                                            value="Wiederbeschaffungskosten"
                                            >Wiederbeschaffungskosten</ion-select-option
                                        >
                                        <ion-select-option
                                            value="Verdienstausfall"
                                            >Verdienstausfall</ion-select-option
                                        >
                                        <ion-select-option
                                            value="Wertverminderung"
                                            >Wertverminderung</ion-select-option
                                        >
                                        <ion-select-option value="Sonstiges"
                                            >Sonstiges</ion-select-option
                                        >
                                    </base-select>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <ion-grid>
                        <ion-row class="ion-margin-top ion-margin-bottom">
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="stepBack()"
                                    fill="outline"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col size="6">
                                <ion-button expand="block" @click="submitForm()"
                                    >Absenden</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
            </stepper>
        </form>
    </page>
</template>

<script>
import Page from "@/components/Page";
import PersonalData from "@/components/PersonalData";
import Stepper from "@/components/Stepper";
import StepperItem from "@/components/StepperItem";
import BaseSelect from "@/components/BaseSelect";
import BaseInput from "@/components/BaseInput";
import AccidentData from "@/components/AccidentData";
import BaseTextarea from "@/components/BaseTextarea";
import { schadensmeldung } from "@/mixins/schadensmeldung";
import BaseCheckbox from "@/components/BaseCheckbox";
import InvolvedVehicles from "@/components/InvolvedVehicles";
import BeteiligteData from "@/components/BeteiligteData";
import ContractCard from "@/components/ContractCard";

export default {
    mixins: [schadensmeldung],
    components: {
        Page,
        PersonalData,
        Stepper,
        StepperItem,
        BaseSelect,
        BaseInput,
        AccidentData,
        BaseTextarea,
        BaseCheckbox,
        InvolvedVehicles,
        BeteiligteData,
        ContractCard,
    },
    data() {
        return {
            isOtherKfzInvolved: false,
            feature: "SchadensmeldungRecht",
            formData: {
                mode: "recht",
                formstep: 1,
                polizzenversicherung: "",
                geschlecht: "",
                titel: "",
                vorname: "",
                zuname: "",
                strasse: "",
                hausnr: "",
                stiege: "",
                stock: "",
                tuer: "",
                plz: "",
                ort: "",
                email: "",
                telefon: "",
                geburtsdatum: "",
                rechtsschutzKfz: false,
                rechtsschutzLenker: false,
                rechtsschutzSonstige: false,
                kfzart: "",
                kfzmarke: "",
                kmstand: "",
                beteiligtKfzart: "",
                beteiligtKfzmarke: "",
                beteiligtKennzeichennummer: "",
                beteiligtKfzversicherung: "",
                beteiligtPolizze: "",
                unfallDatum: "",
                unfallUhrzeit: "",
                unfallStrasse: "",
                unfallHausnr: "",
                unfallStiege: "",
                unfallStock: "",
                unfallTuer: "",
                unfallPlz: "",
                unfallOrt: "",
                unfallLand: "",
                unfallBeschreibung: "",
                vorfallVerhindern: "",
                tatbestandsaufnahmePolizei: false,
                strafverfahren: false,
                ansprueche: "",
                beteiligte: [],
            },
        };
    },
    computed: {
        showInvolvedVehicles() {
            let result = false;
            if (
                this.formData.rechtsschutzKfz ||
                this.formData.rechtsschutzLenker
            ) {
                result = true;
            }
            return result;
        },
        stepCount() {
            return 3 + this.showInvolvedVehicles;
        },
    },
    methods: {},
};
</script>

<style></style>
